module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: _vm.activeMenuDeal,
    attrs: {
      "to": {
        name: 'DealsNew'
      }
    }
  }, [_c('md-icon', [_vm._v("work")]), _vm._v(" "), _c('span', [_vm._v("Заявки")])], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: _vm.activeMenuRouteList,
    attrs: {
      "to": {
        name: 'Itineraries'
      }
    }
  }, [_c('md-icon', [_vm._v("assignment")]), _vm._v(" "), _c('span', [_vm._v("Маршрутные листы")])], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: _vm.activeMenuDocument,
    attrs: {
      "to": {
        name: 'Documents'
      }
    }
  }, [_c('md-icon', [_vm._v("receipt_long")]), _vm._v(" "), _c('span', [_vm._v("Документы")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3317b7aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/menus/MainMenu.vue
// module id = 1104
// module chunks = 0